import { ACTION_TYPE, GETTER_TYPE, MUTATION_TYPE } from './types'
import messagesApi from '@/api/messages'

export default {
  state: {
    contacts: []
  },
  mutations: {
    [MUTATION_TYPE.setContacts]: (state, contacts) => {
      state.contacts = contacts
    }
  },
  actions: {
    [ACTION_TYPE.fetchContacts]: ({ commit }) => new Promise((resolve, reject) => {
      messagesApi.fetchContacts().then(({ data }) => {
        commit(MUTATION_TYPE.setContacts, data.contacts)
        resolve()
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getters: {
    [GETTER_TYPE.getContacts]: (state) => state.contacts
  }
}
